const features = [
  {
    title: '韩漫精选：都市浪漫特辑',
    desc: '精选高分韩漫，从职场恋爱到奇幻穿越，下拉式阅读体验流畅，画风精致唯美，每一部都是人气口碑双丰收的佳作。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20urban%20romance%20scene%2C%20two%20characters%20in%20modern%20city%20setting%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20delicate%20line%20art%2C%20soft%20emotional%20atmosphere%2C%20minimalist%20background%2C%20webtoon%20aesthetic&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '韩漫',
    badge: '人气推荐',
  },
  {
    title: '日漫经典：热血冒险篇章',
    desc: '收录最受欢迎的少年热血日漫，战斗场面震撼、剧情紧凑，从经典老番到最新连载，满足你对冒险的一切幻想。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20action%20adventure%20scene%2C%20dynamic%20composition%20with%20warm%20amber%20and%20cream%20tones%2C%20energetic%20pose%2C%20shonen%20manga%20aesthetic%2C%20clean%20background%2C%20soft%20lighting&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '日漫',
    badge: '经典必看',
  },
  {
    title: '国漫崛起：国风仙侠世界',
    desc: '国漫精品合集，仙侠奇幻与历史传说交相辉映，画风独具东方韵味，故事情节扣人心弦，见证国漫的飞速成长。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20fantasy%20xianxia%20scene%2C%20flowing%20robes%20and%20ancient%20architecture%2C%20warm%20golden%20and%20cream%20tones%2C%20elegant%20brushwork%20style%2C%20ethereal%20atmosphere%2C%20soft%20lighting&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '国漫',
    badge: '品质精选',
  },
  {
    title: '奇幻异世界：穿越冒险合集',
    desc: '当下最火的穿越异世界题材漫画汇总，从转生勇者到反派千金，脑洞大开的设定让你一口气追到最新话。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20isekai%20manga%20style%20illustration%20of%20magical%20world%20gateway%2C%20warm%20coral%20and%20golden%20color%20palette%2C%20dreamy%20atmosphere%2C%20adventure%20themed%2C%20soft%20storytelling%20mood%2C%20clean%20composition&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '奇幻',
    badge: '新番速递',
  },
  {
    title: '悬疑推理：烧脑高分神作',
    desc: '精选高分悬疑漫画，从密室逃脱到连环谜案，每一页都让你屏息凝神。逻辑严密、反转精彩，推理迷不可错过。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20style%20illustration%2C%20shadowy%20moody%20atmosphere%20with%20warm%20amber%20highlights%2C%20detective%20theme%2C%20clean%20composition%2C%20suspenseful%20vibe%2C%20minimalist%20background&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '悬疑',
    badge: '高分必看',
  },
  {
    title: '恋爱甜宠：心跳加速合集',
    desc: '从校园初恋到办公室恋情，最甜最暖的恋爱漫画都在这里。画风清新唯美，剧情甜而不腻，治愈你的每一天。',
    img: 'https://readdy.ai/api/search-image?query=Romance%20manga%20style%20illustration%20of%20sweet%20couple%20moment%20in%20cherry%20blossom%20setting%2C%20warm%20pink%20and%20cream%20color%20palette%2C%20soft%20romantic%20atmosphere%2C%20shoujo%20manga%20aesthetic%2C%20clean%20background&width=800&height=500&seq=carousel-06&orientation=landscape',
    tag: '恋爱',
    badge: '甜宠推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            精心策划的漫画专题合集，帮你快速找到感兴趣的好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full">
                    {item.tag}
                  </span>
                  <span className="px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full">
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}